export enum UserTypeEnum {
  FREELANCER = 'freelancer',
  CLIENT = 'client',
}
